/**
 * The grand hall: a double-height salon with a string course at the old
 * cornice line, pilasters, paired benches, and monumental clusters that climb
 * far above the eye line. The wing's statement room.
 */

import { PALACE } from '../constants';
import { rectSegments } from '../hang';

const grandHall = {
  id: 'grandHall',
  role: 'wing',
  weight: 1.4,

  plan(rand, { axis }) {
    const long = 14 + rand() * 3.5;
    const cross = 11 + rand() * 2;
    return {
      w: axis === 'x' ? long : cross,
      d: axis === 'x' ? cross : long,
      height: 9.5,
    };
  },

  segments(node) {
    // Tall room, same hang band as everywhere else: the picture rail is the
    // ceiling of the hang, and the height goes into air above it.
    return rectSegments(node, { longStyle: 'cluster', shortStyle: 'cluster' });
  },

  build(node, T) {
    const { group, colliders } = T.standardShell(node, T.kit, { corniceH: 0.55 });
    const { WALL_T } = T.PALACE;
    const xI1 = node.x1 + WALL_T;
    const xI2 = node.x2 - WALL_T;
    const zI1 = node.z1 + WALL_T;
    const zI2 = node.z2 - WALL_T;

    // String course at the single-storey line, so the height reads as two
    // sweeps rather than one blank cliff. Inset from the corners like the
    // cornice so no trim faces coincide.
    const SC_H = 0.22;
    const SC_P = 0.05;
    const scY = PALACE.WALL_H - 0.3;
    const trim = [
      T.box(xI1, xI2, scY, scY + SC_H, zI2 - SC_P, zI2),
      T.box(xI1, xI2, scY, scY + SC_H, zI1, zI1 + SC_P),
      T.box(xI2 - SC_P, xI2, scY, scY + SC_H, zI1 + SC_P, zI2 - SC_P),
      T.box(xI1, xI1 + SC_P, scY, scY + SC_H, zI1 + SC_P, zI2 - SC_P),
    ];
    group.add(T.mergedMesh(trim, T.kit.materials.trim));

    const cx = (node.x1 + node.x2) / 2;
    const cz = (node.z1 + node.z2) / 2;
    const along = node.x2 - node.x1 >= node.z2 - node.z1;
    for (const s of [-1, 1]) {
      const b = T.bench(
        T.kit,
        cx + (along ? s * 2.2 : 0),
        cz + (along ? 0 : s * 2.2),
        along ? 0 : Math.PI / 2,
        2.4
      );
      group.add(b.mesh);
      colliders.push(b.collider);
    }
    return { group, colliders };
  },
};

export default grandHall;
